import { styled } from "@mui/material/styles";
import { Box, BoxProps } from "@mui/material";

export interface iDraggableListItemProps extends BoxProps {
  active: boolean;
}

export type iDraggableListItemPropsWithBoxProps = iDraggableListItemProps & BoxProps;

export const DraggableListItem: React.FC<iDraggableListItemPropsWithBoxProps> = styled(
  (props: iDraggableListItemPropsWithBoxProps) => <Box {...props} />
)(({ theme, active = false }) => ({
  backgroundColor: active ? theme.palette.primary.main : theme.palette.grey[800],
  border: `1px solid ${active ? theme.palette.info.main : theme.palette.grey[700]}`,
  color: theme.palette.common.white,
  padding: "4px 8px",
  margin: "2px",
  borderRadius: "2px",
}));
